import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Grid, styled } from '@mui/material';

export const StyledPropertiesGrid = styled(Grid)`
    padding: 20px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.blue.darkest};
`;
export const StyledMenuIcon = styled(MoreVertIcon)`
    height: 36px;
    width: 36px;
    rotate: 90deg;
`;
